import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onStartAssessment: () => void;
}

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose, onStartAssessment }) => {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title">{t('form.welcomeModal.title')}</h2>
          <button 
            className="modal-close" 
            onClick={onClose}
            aria-label={t('form.welcomeModal.close')}
          >
            ×
          </button>
        </div>
        
        <div className="modal-body">
          <p className="modal-message">{t('form.welcomeModal.message')}</p>
        </div>
        
        <div className="modal-footer">
          <div className="modal-language-switcher">
            <LanguageSwitcher />
          </div>
          <div className="modal-buttons">
            <button 
              className="modal-button secondary" 
              onClick={onClose}
            >
              {t('form.welcomeModal.close')}
            </button>
            <button 
              className="modal-button primary" 
              onClick={onStartAssessment}
            >
              {t('form.welcomeModal.startAssessment')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
